module.exports = __webpack_public_path__ + "img/Logo-11.465945f1.svg";